import { getClients } from "@/services/clients/api";
import { Client } from "@/types/client";
import { QueryParamsBase, SelectOption } from "@/types/types";
import { Form, message } from "antd";
import { useRef } from "react";
import DebounceSelect, { DebounceSelectRef } from "../DebounceSelect";

export type ClientOption = SelectOption<{ client: Client }>;

type Props = {
  onChange?: (value: { value: string }, option: ClientOption) => void;
};

async function fetchClients(value: string) {
  try {
    const queryParams: QueryParamsBase = {
      filters: {
        name: [value],
      },
    };

    const data = await getClients(queryParams);

    return [
      {
        label: "Ninguno",
        value: "",
        client: undefined,
      },

      ...data.items.map((item: Client) => ({
        label: `${item.name} ${item.type === "company" ? "(Empresa)" : ""} ${
          item.discount_percent ? `· Desc ${item.discount_percent}%` : ""
        }`.trim(),
        value: item.id,
        client: item,
      })),
    ];
  } catch (error) {
    console.error(error);
    message.error("Error al obtener clientes");
    return [];
  }
}

export function ClientSelect({ onChange }: Props) {
  const selectDebounceRef = useRef<DebounceSelectRef>(null);

  return (
    <div className="flex flex-col items-start gap-2 mb-4">
      <Form.Item className="w-full mb-0" name="category_id" label="Cliente">
        <DebounceSelect
          ref={selectDebounceRef}
          placeholder="Busca y selecciona cliente"
          fetchOptions={fetchClients}
          labelInValue
          disabled={false}
          onChange={(val, option) => {
            const opt = Array.isArray(option) ? option[0] : option;

            onChange?.(val as { value: string }, opt as ClientOption);
          }}
        />
      </Form.Item>
    </div>
  );
}
